// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.digital-treasure-section .helmet-icon {
  position: absolute;
  z-index: 2;
  display: none;
}
@media screen and (min-width: 992px) {
  .digital-treasure-section .helmet-icon {
    display: block;
    top: -12rem;
    right: -12rem;
  }
}
@media screen and (min-width: 1024px) {
  .digital-treasure-section .helmet-icon {
    top: -14rem;
    right: -14rem;
  }
}
@media screen and (min-width: 1200px) {
  .digital-treasure-section .helmet-icon {
    top: -15rem;
    right: -15rem;
  }
}
@media screen and (min-width: 1400px) {
  .digital-treasure-section .helmet-icon {
    top: -13rem;
    right: -17rem;
  }
}
.digital-treasure-section .helmet-icon img {
  max-width: 18rem;
}
@media screen and (min-width: 1024px) {
  .digital-treasure-section .helmet-icon img {
    max-width: 20rem;
  }
}
@media screen and (min-width: 1200px) {
  .digital-treasure-section .helmet-icon img {
    max-width: 23rem;
  }
}
@media screen and (min-width: 1400px) {
  .digital-treasure-section .helmet-icon img {
    max-width: 25rem;
  }
}
.digital-treasure-section .right-side-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 2rem 1rem;
}
.digital-treasure-section .right-side-wrapper .text-stroke-bg {
  position: absolute;
  inset: 0;
  z-index: -1;
}
.digital-treasure-section .right-side-wrapper .text-stroke-bg h1 {
  margin: 0;
  font-size: 11.063rem;
  font-weight: 400;
  line-height: 9.688rem;
  text-align: center;
  text-transform: uppercase;
  background: rgba(0, 255, 127, 0.2392156863);
  -webkit-background-clip: text;
  -webkit-text-stroke-color: transparent;
  -webkit-text-stroke-width: 0.125rem;
  color: #000;
}
.digital-treasure-section .right-side-wrapper h4 {
  margin: 0;
  font-size: 3.75rem;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #00ff7f;
  text-transform: uppercase;
  text-align: center;
}
@media screen and (min-width: 320px) {
  .digital-treasure-section .right-side-wrapper h4 {
    font-size: 4.5rem;
    line-height: 1;
  }
}
@media screen and (min-width: 360px) {
  .digital-treasure-section .right-side-wrapper h4 {
    font-size: 5rem;
    line-height: 1;
  }
}
@media screen and (min-width: 567px) {
  .digital-treasure-section .right-side-wrapper h4 {
    font-size: 6rem;
    line-height: 1;
  }
}
@media screen and (min-width: 768px) {
  .digital-treasure-section .right-side-wrapper h4 {
    font-size: 8.125rem;
    line-height: 1;
    letter-spacing: 0.35rem;
    text-align: left;
  }
}
@media screen and (min-width: 992px) and (max-width: 1100px) {
  .digital-treasure-section .right-side-wrapper h4 {
    font-size: 7rem;
    line-height: 1;
    text-align: left;
    letter-spacing: 0.4rem;
  }
}
.digital-treasure-section .right-side-wrapper h4 span {
  font-weight: 400;
  font-size: 3.25rem;
  line-height: 1;
  letter-spacing: 0.02rem;
  color: #fff;
  text-align: center;
}
@media screen and (min-width: 360px) {
  .digital-treasure-section .right-side-wrapper h4 span {
    font-size: 3.5rem;
    line-height: 1;
  }
}
@media screen and (min-width: 567px) {
  .digital-treasure-section .right-side-wrapper h4 span {
    font-size: 4rem;
    line-height: 1;
  }
}
@media screen and (min-width: 768px) {
  .digital-treasure-section .right-side-wrapper h4 span {
    font-size: 5.75rem;
    line-height: 1;
    text-align: left;
  }
}
@media screen and (min-width: 992px) and (max-width: 1100px) {
  .digital-treasure-section .right-side-wrapper h4 span {
    font-size: 5rem;
    line-height: 1;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/home/digital-treasure/style.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;AAAJ;AACI;EAJF;IAKI,cAAA;IACA,WAAA;IACA,aAAA;EAEJ;AACF;AADI;EATF;IAUI,WAAA;IACA,aAAA;EAIJ;AACF;AAHI;EAbF;IAcI,WAAA;IACA,aAAA;EAMJ;AACF;AALI;EAjBF;IAkBI,WAAA;IACA,aAAA;EAQJ;AACF;AAPI;EACE,gBAAA;AASN;AARM;EAFF;IAGI,gBAAA;EAWN;AACF;AAVM;EALF;IAMI,gBAAA;EAaN;AACF;AAZM;EARF;IASI,gBAAA;EAeN;AACF;AAZE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAcJ;AAbI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;AAeN;AAdM;EACE,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;EACA,6BAAA;EACA,sCAAA;EACA,mCAAA;EACA,WAAA;AAgBR;AAbI;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAeN;AAdM;EATF;IAUI,iBAAA;IACA,cAAA;EAiBN;AACF;AAhBM;EAbF;IAcI,eAAA;IACA,cAAA;EAmBN;AACF;AAlBM;EAjBF;IAkBI,eAAA;IACA,cAAA;EAqBN;AACF;AApBM;EArBF;IAsBI,mBAAA;IACA,cAAA;IACA,uBAAA;IACA,gBAAA;EAuBN;AACF;AAtBM;EA3BF;IA4BI,eAAA;IACA,cAAA;IACA,gBAAA;IACA,sBAAA;EAyBN;AACF;AAxBM;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AA0BR;AAzBQ;EAPF;IAQI,iBAAA;IACA,cAAA;EA4BR;AACF;AA3BQ;EAXF;IAYI,eAAA;IACA,cAAA;EA8BR;AACF;AA7BQ;EAfF;IAgBI,kBAAA;IACA,cAAA;IACA,gBAAA;EAgCR;AACF;AA/BQ;EApBF;IAqBI,eAAA;IACA,cAAA;IACA,gBAAA;EAkCR;AACF","sourcesContent":[".digital-treasure-section {\n  .helmet-icon {\n    position: absolute;\n    z-index: 2;\n    display: none;\n    @media screen and (min-width: 992px) {\n      display: block;\n      top: -12rem;\n      right: -12rem;\n    }\n    @media screen and (min-width: 1024px) {\n      top: -14rem;\n      right: -14rem;\n    }\n    @media screen and (min-width: 1200px) {\n      top: -15rem;\n      right: -15rem;\n    }\n    @media screen and (min-width: 1400px) {\n      top: -13rem;\n      right: -17rem;\n    }\n    img {\n      max-width: 18rem;\n      @media screen and (min-width: 1024px) {\n        max-width: 20rem;\n      }\n      @media screen and (min-width: 1200px) {\n        max-width: 23rem;\n      }\n      @media screen and (min-width: 1400px) {\n        max-width: 25rem;\n      }\n    }\n  }\n  .right-side-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    align-items: center;\n    padding: 2rem 1rem;\n    .text-stroke-bg {\n      position: absolute;\n      inset: 0;\n      z-index: -1;\n      h1 {\n        margin: 0;\n        font-size: 11.063rem;\n        font-weight: 400;\n        line-height: 9.688rem;\n        text-align: center;\n        text-transform: uppercase;\n        background: #00ff7f3d;\n        -webkit-background-clip: text;\n        -webkit-text-stroke-color: transparent;\n        -webkit-text-stroke-width: 0.125rem;\n        color: #000;\n      }\n    }\n    h4 {\n      margin: 0;\n      font-size: 3.75rem;\n      line-height: 1;\n      font-weight: 700;\n      letter-spacing: 0.03em;\n      color: #00ff7f;\n      text-transform: uppercase;\n      text-align: center;\n      @media screen and (min-width: 320px) {\n        font-size: 4.5rem;\n        line-height: 1;\n      }\n      @media screen and (min-width: 360px) {\n        font-size: 5rem;\n        line-height: 1;\n      }\n      @media screen and (min-width: 567px) {\n        font-size: 6rem;\n        line-height: 1;\n      }\n      @media screen and (min-width: 768px) {\n        font-size: 8.125rem;\n        line-height: 1;\n        letter-spacing: 0.35rem;\n        text-align: left;\n      }\n      @media screen and (min-width: 992px) and (max-width: 1100px) {\n        font-size: 7rem;\n        line-height: 1;\n        text-align: left;\n        letter-spacing: 0.4rem;\n      }\n      span {\n        font-weight: 400;\n        font-size: 3.25rem;\n        line-height: 1;\n        letter-spacing: 0.02rem;\n        color: #fff;\n        text-align: center;\n        @media screen and (min-width: 360px) {\n          font-size: 3.5rem;\n          line-height: 1;\n        }\n        @media screen and (min-width: 567px) {\n          font-size: 4rem;\n          line-height: 1;\n        }\n        @media screen and (min-width: 768px) {\n          font-size: 5.75rem;\n          line-height: 1;\n          text-align: left;\n        }\n        @media screen and (min-width: 992px) and (max-width: 1100px) {\n          font-size: 5rem;\n          line-height: 1;\n          text-align: left;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
